import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { CollegeCourseInfo } from '../../application/application.service';

@Component({
    selector: 'coursedescription-dialog-component',
    styleUrls: ['coursedescription.dialogcomponent.css'],
    templateUrl: 'coursedescription.dialogcomponent.html'
})
export class CourseDescriptionDialogComponent implements OnInit {
    title: string;
    message: string;
    oktext: string;
    Course: CollegeCourseInfo;

    constructor(public dialogRef: MatDialogRef<CourseDescriptionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data : _CourseDescriptionDialogOptions) {
        this.title = data.TitleText || 'Please wait...';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || '';
        this.Course = data.Course;
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    ngOnInit() {

    }

    OKHandler() {
        this.dialogRef.close(true);
    }
}

export class _CourseDescriptionDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    Course?: CollegeCourseInfo;
}


// WEBPACK FOOTER //
// ./src/services/dialogs/coursedescription/coursedescription.dialogcomponent.ts